// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1hkBZ","info":"PatientInfo_info__1N7-l"};